// extracted by mini-css-extract-plugin
export default {"reject-modal":"RejectModal_reject-modal__6TOp9"};